<template>
  <div class="opt-outed-wrapper flex center-all">
    <div
      id="opt-outed"
      class="info flex center-all"
      @click.stop>
      <p>Why I am seeing this?</p>
      <SBIcon
        :icon="SBIconList.INFO"
        :color="SBColors.blackPrimary"
        :size="12"/>
      <b-popover
        target="opt-outed"
        triggers="hover"
        placement="auto"
        custom-class="big red">
        <div>
          <h1>Contact opted-out</h1>
          <p>Contact opted-out from receiving messages from your number by sending opt-out keyword.</p>
        </div>
      </b-popover>
    </div>
    <div
      class="opt-outed flex center-all" >
      <p>Messaging disabled</p>
    </div>
  </div>
</template>

<script>
import SBIcon from '@/components/common/Icon';
import SBIconList from '@/helpers/lists/sb-icon-list';
import SBColors from '@/helpers/lists/colors';

export default {
  name: 'UserOptOuted',
  components: {
    SBIcon,
  },
  data() {
    return {
      SBIconList,
      SBColors,
    };
  },
};
</script>

<style lang="scss" scoped>
.opt-outed-wrapper {
  position: relative;
  .info {
    position: absolute;
    top: -28px;
    cursor: default;
    padding: 3px 9px;
    z-index: 51;
    border-radius: 10px;
    background-color: $white;

    p {
      font-size: 12px;
      font-weight: 500;
      line-height: 1.4;
      color: $blackPrimary;
    }

    .sb-icon {
      margin-left: 5px;
    }
  }

  .opt-outed {
    cursor: default;
    border-radius: 5px;
    padding: 9px;
    margin: 0 15px 15px;
    background-color: $redButtonLight;
    border: none;
    width: 100%;

    .sb-icon {
      margin-right: 5px;
    }

    p {
      font-size: 14px;
      font-weight: 500;
      line-height: 1.2;
      color: $redPrimary;
    }
  }
}
</style>
